export default __webpack_public_path__ + "static/media/jee_legacy_web.246d4f41.svg";